/* eslint-disable */

import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import { useNotificationStore } from "@/common";
import { axios } from "@/library/axios";
import type { BaseResponse } from "@/types";
import { displayError } from "@/utils/functions/displayError";

import type { Content, FxGetUserOrdersResType } from "../types/ResponseTypes";
import type { FxGetCustomerOrdersReqType } from "../types/ResquestTypes";

const initialData: Content[] = [
  {
    id: "",
    refId: "",
    orderId: "",
    category: "transaction",
    customerInfo: {
      omFxCustomerId: "",
      name: "",
      email: "",
      mobileNumber: "",
    },
    forexCardNumber: "",
    reloadingCategory: "",
    transactionType: "",
    transactionStatus: "",
    transactionProcess: "",
    videoKycLink: "",
    vKycStatusUpdateTime: "",
    purposeOfTransaction: "",
    transactionItems: [
      {
        id: "",
        transactionType: "",
        currency: "",
        amount: 0,
        amountInInr: 0,
        exchangeRate: 0,
        exchangeTime: "",
      },
    ],
    payments: [
      {
        id: "",
        paymentMode: "",
        freezePrice: true,
        buyback: true,
        couponId: "",
        purchaseAmount: 0,
        igst: 0,
        sgst: 0,
        cgst: 0,
        gst: 0,
        tcs: 0,
        taxableAmount: 0,
        gstTaxableAmount: "",
        gstServiceCharge: "",
        serviceCharge: 0,
        discount: "",
        amountPayable: 0,
        amountPending: "",
        freezeCharge: 0,
        buybackCharge: 0,
        freezeTime: "",
        payoutAccount: "",
        outwardRemittanceAccount: "",
        paymentStatus: "",
        pgOrderId: "",
        orderId: "",
        amountPaid: 0,
        paymentUtr: "",
        paymentTime: "",
        paymentBankName: "",
        pgName: "",
        paymentMethod: "",
        paymentCreatedAt: "",
      },
    ],
    appointmentInfo: {
      name: "",
      email: "",
      phone: "",
      pincode: "",
      address: "",
      city: "",
      state: "",
      branchId: "",
      day: "",
      timeslot: "",
      duration: 0,
      documentVerificationType: "",
    },
    documentsVerified: true,
    documentData: "",
    transactorInfo: {
      transactorName: "",
      transactorEmail: "",
      transactorPhone: "",
      transactorPincode: "",
      transactorAddress: "",
      transactorCity: "",
      transactorState: "",
      transactorCategory: 0,
      travellingTo: "",
      travelEndDate: "",
      travelStartDate: "",
    },
    receiverInfo: {
      name: "",
      mobileNo: "",
      relationship: "",
      bankName: "",
      branchName: "",
      accountNo: "",
      documents: "",
      swiftCode: "",
    },
    payoutAccount: {
      accountNo: "",
      ifscCode: "",
      swiftCode: "",
      accountHolderName: "",
      bankName: "",
      branch: "",
      address: "",
      pennyValidationStatus: 0,
    },
    createdAt: "",
    vkycStatus: "",
    vkycStatusUpdateTime: "",
  },
];

const getOrders = async (
  payload: FxGetCustomerOrdersReqType
): Promise<
  BaseResponse<FxGetUserOrdersResType, FxGetCustomerOrdersReqType>
> => {
  return axios<
    FxGetCustomerOrdersReqType,
    BaseResponse<FxGetUserOrdersResType, FxGetCustomerOrdersReqType>,
    FxGetCustomerOrdersReqType
  >({
    url: `/fx/customers/${payload.customerId}/transactions?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`,
    method: "get",
  });
};

export const useGetOrders = (payload: FxGetCustomerOrdersReqType) => {
  const { addNotification } = useNotificationStore();

  const [ordersData, setOrdersData] =
    useState<FxGetUserOrdersResType["content"]>([]);

  const { data, isLoading, error } = useQuery({
    queryKey: ["exhange-rates", payload],
    queryFn: () => getOrders(payload),
    useErrorBoundary: false,
    enabled: !!payload.customerId,
    onSuccess: () => {
      // addNotification({
      //   type: "success",
      //   title: "success",
      //   message: "Orders fetched successfully",
      // });
    },
  });

  useEffect(() => {
    if (data) {
      const resultData = data?.data.data.content;
      if (resultData) setOrdersData(resultData);
    }
  }, [data]);

  useEffect(() => {
    displayError(error);
  }, [error]);

  return {
    ordersData,
    isLoading,
  };
};
